import React, {Component} from 'react';
import './breadCrumb.css';

export default class BreadcrumbWithoutAjax extends Component {
    constructor(props) {
		super(props);
    }

    render(){
        let categoryData = this.props.categoryData;
        let maxLength = categoryData.length -1;
        //Updated
        var html = categoryData.map((item, index)=>{
            if(index < maxLength){
                return (
                    <React.Fragment key={index}>
                        <a href={item.href}>
                            <div className="item">{item.name}</div>
                        </a>
                        <div className='item'>/</div>
                    </React.Fragment>
                );
            }
            else{
                return (
                    <React.Fragment key={index}>
                        <div className="item active">{item.name}</div>
                        <div className='item'></div>
                    </React.Fragment>
                );
            }
        });

        return (
            <div id="breadCrumb">{html}</div>
        );
    }
}